import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** GET LOAN PROPOSAL LIST START *********************** */
export const commonLoanProposalListGet = (listData: any) => {
	const data = {
		GetLoanProposalListToken: listData,
	};
	const url = `${API_URL}getAllLoanIndexDetailsList`;
	return makeApiCall(url, data);
};
/** ***************** GET LOAN PROPOSAL LIST END *********************** */

/** ***************** REVERT LOAN INDEX DETAILS START *********************** */
export const loanIndexDetailsRevert = (revertData: any) => {
	const data = {
		LoanIndexRevertToken: revertData,
	};
	const url = `${API_URL}updateLoanIndexRevert`;
	return makeApiCall(url, data);
};
/** ***************** REVERT LOAN INDEX DETAILS END *********************** */

/** ***************** GET GROUP MEMBER LIST START *********************** */
export const getWholeGroupMemberListGet = (listData: any) => {
	const data = {
		GetWholeGroupMemberDetailsToken: listData,
	};
	const url = `${API_URL}GetWholeGroupMemberListToken`;
	return makeApiCall(url, data);
};
/** ***************** GET GROUP MEMBER LIST END *********************** */

/** ***************** FETCH PARTICULAR LOAN INDEX START *********************** */
export const fetchParticularLoanIndexListAPI = (encodeData: any) => {
	const data = {
		GetParticularLoanIndexToken: encodeData,
	};
	const url = `${API_URL}GetParticularLaonIndexInfoWithToken`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PARTICULAR LOAN INDEX END *********************** */

/** ***************** FETCH HOLIDAY LIST START *********************** */
export const fetchHolidayList = (fetchData: any) => {
	const data = {
		GetHolidayDataToken: fetchData,
	};
	const url = `${API_URL}GetHolidayToken`;
	return makeApiCall(url, data);
};
/** ***************** FETCH HOLIDAY LIST END *********************** */

/** ***************** GET MEMBER LOAN PRODUCT EXIST START *********************** */
export const getMemberLoanProductExistDetails = (fetchData: any) => {
	const data = {
		GetMemberLoanProductExistDataToken: fetchData,
	};
	const url = `${API_URL}GetMemberLoanProductExistToken`;
	return makeApiCall(url, data);
};
/** ***************** GET MEMBER LOAN PRODUCT EXIST END *********************** */

/** *****************  APPROVE LOAN INDEX START *********************** */
export const loanIndexDetailsApprove = (fetchData: any) => {
	const data = {
		LoanIndexApproveToken: fetchData,
	};
	const url = `${API_URL}updateLoanIndexApprove`;
	return makeApiCall(url, data);
};
/** *****************  APPROVE LOAN INDEX END *********************** */

/** ***************** DELETE LOAN INDEX DETAILS START *********************/
export const loanIndexDetailsDelete = (fetchData: any) => {
	const data = {
		DeleteParticularLoanIndexToken: fetchData,
	};
	const url = `${API_URL}deleteParticularLoanIndex`;
	return makeApiCall(url, data);
};
/** ***************** DELETE LOAN INDEX DETAILS END *********************/

/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS START *********************/
export const deleteMemberInLoanIndexDetails = (fetchData: any) => {
	const data = {
		DeleteParticularMemberInLoanIndexToken: fetchData,
	};
	const url = `${API_URL}DeleteParticularMemberInLoanIndexWithToken`;
	return makeApiCall(url, data);
};
/** ***************** DELETE MEMBER IN LOAN INDEX DETAILS END *********************/

/** ***************** REVERT LOAN PROPOSAL APPROVE DETAILS START *********************** */
export const loanProposalApproveDetailsRevert = (revertData: any) => {
	const data = {
		LoanIndexApproveRevertToken: revertData,
	};
	const url = `${API_URL}UpdateLoanIndexApproveRevertWithToken`;
	return makeApiCall(url, data);
};
/** ***************** REVERT CUSTOM PRODUCT LOAN DETAILS END *********************** */

/*********** HDFC CREATE INDIVIDUAL QRCODE START ************************ */
export const createHDFCIndividualLoanQRCode = (fetchData: any) => {
	const data = {
		CreateNewIndividualLoanQRForHDFCToken: fetchData,
	};
	const url = `${API_URL}HdfcCollection/hdfcCreateIndividualLoanQrCode`;
	return makeApiCall(url, data);
};
/*********** HDFC CREATE INDIVIDUAL QRCODE END ************************ */

/*********** GET APPRAISAL LOG START ************************ */
export const getAppraisalLogDetails = (fetchData: any) => {
	const data = {
		LoanAppraisalDetailsToken: fetchData,
	};
	const url = `${API_URL}GetLoanAppraisalDetailsList`;
	return makeApiCall(url, data);
};
/*********** GET APPRAISAL LOG END ************************ */

/*********** MOVE TO PARTICULAR APPRAISAL START ************************ */
export const moveToParticularAppraisalDetails = (moveData: any) => {
	const data = {
		MoveToParticularAppraisalToken: moveData,
	};
	const url = `${API_URL}MoveToParticularAppraisal`;
	return makeApiCall(url, data);
};
/*********** MOVE TO PARTICULAR APPRAISAL END ************************ */

/*********** LOAN APPROVE OTP START ************************ */
export const loanApproveOTPDetails = (fetchData: any) => {
	const data = {
		LoanApproveOTPToken: fetchData,
	};
	const url = `${API_URL}LoanApproveOtp`;
	return makeApiCall(url, data);
};
/*********** LOAN APPROVE OTP END ************************ */
